import EleFormUploadFile from './EleFormUploadFile'

export default EleFormUploadFile
